import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import ViewUIPlus from 'view-ui-plus';
import util from '@/libs/util';
import Setting from '@/setting';
import store from '@/store/index';
import { includeArray } from '@/libs/system';

// 路由数据
import routes from './routes';
import Token from '../plugins/auth/token';

// 导出路由 在 main.js 里使用
var router = createRouter({
  history: Setting.routerMode === 'history' ? createWebHistory(Setting.routerBase) : Setting.routerMode === 'hash' ? createWebHashHistory(Setting.routerBase) : createMemoryHistory(Setting.routerBase),
  routes: routes
});

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(function (to, from, next) {
  // if (Setting.showProgressBar && !["login","register"].includes(to.name)) ViewUIPlus.LoadingBar.start();
  // 判断是否需要登录才可以进入
  // if (to.matched.some(_ => _.meta.auth)) {
  // 这里依据 token 判断是否登录，可视情况修改
  var noLogin = to.meta.noLogin;
  if (!noLogin) {
    if (Token.get()) {
      store.dispatch('admin/enum/asyncGetEnumAll');
      if (store.state.admin.account.hasGetUser) {
        var auth = to.meta.auth;
        if (auth) {
          store.dispatch('admin/db/get', {
            dbName: 'sys',
            path: 'user.info',
            defaultValue: {},
            user: true
          }, {
            root: true
          }).then(function (userInfo) {
            var access = userInfo.access;
            var isPermission = includeArray(auth, access);
            if (isPermission) {
              next();
            } else {
              next({
                name: '403'
              });
            }
          });
        } else {
          next();
        }
      } else {
        /**
         * 获取登录用户信息
         */
        store.dispatch('admin/account/getLoginUser', {
          next: next,
          to: to
        }).catch(function (err) {
          store.dispatch('admin/account/logout', {
            to: to
          });
        });
      }
    } else {
      store.dispatch('admin/account/logout', {
        to: to
      });
    }
  } else {
    next();
  }
});
router.afterEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to) {
    var pageName, opened, pageOpened;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // if (Setting.showProgressBar && !["login","register"].includes(to.name)) ViewUIPlus.LoadingBar.finish();
          pageName = to.params.pageName;
          _context.n = 1;
          return store.dispatch('admin/db/get', {
            dbName: 'sys',
            path: 'page.opened',
            defaultValue: Setting.page.opened,
            user: true
          }, {
            root: true
          });
        case 1:
          opened = _context.v;
          pageOpened = opened.find(function (page) {
            return page.name === to.name;
          });
          pageName = pageName ? pageName : pageOpened ? pageOpened.pageName : null;

          // delete to.params.pageName
          if (!('meta' in to) || to.meta && !('tabs' in to.meta) || to.meta && to.meta.tabs) {
            store.dispatch('admin/page/open', _objectSpread(_objectSpread({}, to), {}, {
              pageName: pageName
            }));
          }
          // 更改标题
          util.title({
            title: pageName ? pageName : to.meta.title
          });
          // 返回页面顶端
          window.scrollTo(0, 0);
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export default router;